
<div class="ui segment contents" style="width: 1000px;">
  <div v-if="form.hasErrors()" class="ui warning message">入力エラー</div>
  <form class="ui form" :class="{'loading': form.waiting, 'warning': form.hasErrors()}">
    <div class="field">
      <button type="button" class="ui positive button" @click="save()" :class="{'loading': form.waiting}">保存する</button>
    </div>
    <basic-shop :form="form" is-new></basic-shop>
  </form>
</div>
